module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/df4f661a03ad7a29f81cb0cd95e60c38.png";